import React from "react";
import LeftPannel from "./LeftPannel";
import Header from "./Header";
import Main from "./Main";

const COLLAPSED_STORAGE_KEY = "vg.nav.collapsed";

/** Read once on mount; a bad or missing value just means expanded. */
function readCollapsed(): boolean {
  try {
    return window.localStorage.getItem(COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

const AppShell = () => {
  // Two independent pieces of state, because they are two different behaviours
  // that happen to involve the same component:
  //   open      - the drawer, below lg only, always starts closed
  //   collapsed - the rail, from lg up, remembered between visits
  const [navOpen, setNavOpen] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(readCollapsed);

  const closeNav = React.useCallback(() => setNavOpen(false), []);
  const openNav = React.useCallback(() => setNavOpen(true), []);

  const toggleCollapsed = React.useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      // Persisting is a nicety, so a storage failure (private mode, quota) must
      // not stop the sidebar from collapsing.
      try {
        window.localStorage.setItem(COLLAPSED_STORAGE_KEY, String(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  return (
    <div className="h-full flex min-h-0">
      <LeftPannel
        open={navOpen}
        onClose={closeNav}
        collapsed={collapsed}
        onToggleCollapsed={toggleCollapsed}
      />
      <div className="flex flex-col grow min-h-0 min-w-0">
        <Header onMenuClick={openNav} />
        <Main />
      </div>
    </div>
  );
};

export default AppShell;
